export const dataDomain = state => state.Data;
export const rootDomain = state => state.root;
export const loaderDomain = state => state.root.loader;
export const unsubscribeFormDomain = state => state.root.unsubscribeForm;
